import { z } from 'zod';

export const ExperienceFragmentSchema = z.object({
  title: z.string(),
  templateType: z.string(),
  ':itemsOrder': z.array(z.string()),
  ':items': z.object({
    root: z.object({
      ':itemsOrder': z.array(z.string()),
      ':items': z.record(
        z.object({
          id: z.string(),
          text: z.string(),
        })
      ),
      columnClassNames: z.record(z.string()).optional(),
      gridClassNames: z.string().optional(),
      columnCount: z.number().optional(),
    }),
  }),
});

export type ExperienceFragmentResponse = z.infer<typeof ExperienceFragmentSchema>;
